import { IconButton, MenuItem } from "@material-ui/core";
import { GridRowData } from "@material-ui/data-grid";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import { useEffect, useMemo, useReducer, useState } from "react";
import { connect, useDispatch } from "react-redux";
//import en from '../../../../lang/en-us';
import en from "../../../lang/en-us";
import { SubmitButton } from "../../../lib/Button";
import {
  TableColumn,
  TableCellParams,
  TableWithCollapse,
} from "../../../lib/DataTable";
import { fetchInvestorDetails } from "../../../store/actions/nct";

// import { RootStateType } from '../../../../redux-store/reducers';
import { RootStateType } from "../../../store/reducers/index";
//import { INVESTOR_OBJECT } from '../../../store/types/nct';
//import { LIST_PROTFOLIO_PAYLOAD } from '../../../store/types/portfolio';

import {
  getErrorMessage,
  getInvestorFunds,
  minorBelowEighteenYears,
  modeOfHoldingSingle,
  portfoliosByMinorStatus,
  portfoliosByTransactionResource,
} from "../portfolios/utils";
import { NomineeInfoRowData } from "./types";
import {
  EQUITY,
  LIQUID,
  DEBT,
  OTHER,
  UPDATE_NOMINEE,
} from "../../../utils/constants";
import NoFoliosFound from "../NoFoliosFound";
import { useTableWithCollapse } from "../../../lib/DataTable/customHooks";
import { getMatchAndUnMatchedFunds } from "../../../utils/utilityFunctions";
import { INITIALIZE_NOMINEE_ARRAY } from "../../../store/types/nominees";
import CustomizedSelect from "../transactions/customizedSelect";
import { groupFilteredData } from "../utils";
import { useMobileEmailFilter } from "../useMobileEmailFilter";
import { ActionHeader, BackArrow } from "../UpdateNominee/SelectedFolios";

const { dashboard } = en;

const _renderNominee = ({ row, setCollapse, collapse }: TableCellParams) => {
  return (
    <>
      {row.noNominee === "Y" ? (
        <span>Opted Out of Nomination</span>
      ) : row.nominees.length ? (
        <>
          <span>Yes</span>
          <IconButton
            className="update-nominee-collapse-btn"
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              setCollapse((open: boolean) => !open);
            }}
          >
            {!collapse ? (
              <>
                <span>View</span>
                <KeyboardArrowDown />
              </>
            ) : (
              <>
                <span>Hide</span>
                <KeyboardArrowUp />
              </>
            )}
          </IconButton>
        </>
      ) : (
        <span>No Nominees Added</span>
      )}
    </>
  );
};

const _renderModeofHolding = ({ row }: TableCellParams) => (
  <div>{row.modeOfHolding === "1" ? "Single" : "---"}</div>
);
export const mohMap: {
  [key: number]: string;
} = {
  1: "Single",
  2: "Joint",
  3: "Either or Survivor",
  4: "Anyone or Survivor",
  5: "Not applied",
};

const Columns: TableColumn[] = [
  {
    field: "id",
    headerName: "FOLIO",
    valueGetter: ({ row }) => row.folio,
  },
  {
    field: "amcName",
    headerName: "Fund House",
    width: 300,
    filterBy: true,
  },
  {
    field: "investorName",
    headerName: "PRIMARY HOLDER",
    width: 200,
  },
  {
    field: "modeOfHolding",
    headerName: "Mode of Holding",
    valueGetter: ({ row }) => {
      if (row.modeOfHolding === null) {
        return "NA";
      }
      const moh = mohMap[row.modeOfHolding];
      if (moh) {
        return moh;
      } else {
        return "Others";
      }
    },
    width: 150,
  },
  {
    field: "nominees",
    renderCell: _renderNominee,
    headerName: "NOMINEE Details",
    width: 150,
  },
  {
    isFilter: true,
    field: "assetType",
    headerName: "Category",
    filterBy: true,
    renderStaticFilters: [EQUITY, LIQUID, DEBT, OTHER],
  },
];

function Nominee(props: any) {
  const [rowData, setRowData] = useState<NomineeInfoRowData[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const { filterState, setGroupFilterMap, filterDispatch } =
    useMobileEmailFilter(rowData);
  const { emailMobileKeys, currentKey, groupedFilterMap } = filterState;

  const { selectedRows, setSelectedRows, tableColumns, tableRows, ...filters } =
    useTableWithCollapse<NomineeInfoRowData[]>({
      rows: currentKey ? groupedFilterMap[currentKey] : rowData,
      columns: Columns,
      loading,
    });

  const { userRegisteredWith } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(true);
    async function callApi() {
      const payload = {
        pan: props.investorData.PAN,
        brokercode: props.token,
      };

      try {
        // await props.getPortfolio(payload);
        const { body: investorDetails = {} } = await props.fetchInvestorDetails(
          payload
        );
        const { success: nomineeFunds = [] } = investorDetails;
        const filters = [
          modeOfHoldingSingle,
          portfoliosByMinorStatus,
          portfoliosByTransactionResource,
        ];
        const funds = getMatchAndUnMatchedFunds(
          filters,
          getInvestorFunds(nomineeFunds),
          true
        ).map((fund) => {
          return { ...fund, error: getErrorMessage(fund, filters) };
        });
        const { nomineeFunds: _nomineeFunds = [], otherFunds = [] } =
          funds.reduce((prev: any, fund: NomineeInfoRowData) => {
            if (fund?.nominees?.length) {
              return {
                ...prev,
                nomineeFunds: [...(prev.nomineeFunds ?? []), fund],
              };
            }
            return { ...prev, otherFunds: [...(prev.otherFunds ?? []), fund] };
          }, []);
        setRowData([...otherFunds, ..._nomineeFunds]);
        setLoading(false);
      } catch (err: any) {
        console.trace(err);
        alert(err.message);
      }
    }
    callApi();
    return () => { };
  }, []);

  useEffect(() => {
    if (rowData.length > 0) {
      const groupedFilterMap = groupFilteredData(rowData);
      setGroupFilterMap(groupedFilterMap);
    }
  }, [rowData]);

  // clear selected rows on changing the value in the filter drop down
  useEffect(() => {
    setSelectedRows([]);
  }, [currentKey]);

  const _rederCollapse = ({ row }: { row: GridRowData }) => {
    const { nominees = [] } = row;
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          width: "100%",
          flexWrap: "wrap",
        }}
      >
        {new Array(3).fill("").map((_, index) => (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: 150,
            }}
          >
            <label>Nominee {index + 1}</label>
            <label>{nominees[index] ? nominees[index].name : "N/A"}</label>
          </div>
        ))}
      </div>
    );
  };

  const TableBody = useMemo(() => {
    return (
      <TableWithCollapse
        renderCollapse={_rederCollapse}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        columns={tableColumns}
        rows={tableRows}
        toolTipTextGetter={({ row }) => (row.isDisabled ? row.error : "")}
        isRowSelectable={({ row }) => (row.isDisabled ? false : true)}
        checkBoxEnabled={true}
        toolTipEnabled
        {...filters}
      />
    );
  }, [tableColumns, tableRows, selectedRows, filters]);

  const handleFilterKeyChange = (e: any) => {
    filterDispatch({
      type: "SET_FILTER_KEY",
      payload: e.target.value,
    });
  };

  return (
    <div className="curved-bg">
      <BackArrow history={props.history} />
      <div className="curved-bg-content">
        <h5 style={{ marginLeft: "10px" }}>Update Nominee Details</h5>
        <div className="update-nominee-main">
          {tableRows.length > 0 && currentKey && (
            <div
              className="appbar-div dual-margin input-name-responsive"
              style={{ display: "flex", gap: "1%", marginLeft: "15px" }}
            >
              <div
                className="input-name input-name-sizing-responsive"
                style={{
                  alignItems: "center",
                  display: "flex",
                  marginBottom: "0",
                }}
              >
                Select Email-Mobile Combination
              </div>
              <CustomizedSelect
                handleChange={handleFilterKeyChange}
                value={currentKey}
                emailStyle={true}
              // inputRef={(ele) => (this.reportTypeField = ele)}
              // isError={reportType.isError}
              // errorMessage={reportType.errorMessage}
              // isShowError={reportType.isError}
              //placeholder="Select Report Type"
              >
                {emailMobileKeys &&
                  emailMobileKeys.map((item) => (
                    <MenuItem value={item} key={item}>
                      {item}
                    </MenuItem>
                  ))}
              </CustomizedSelect>
            </div>
          )}
          {/* <div className="db-content mobile-db-content"> */}
          <div className="db-content-right full-width">
            <div className="maxWidth">
              <div className="curved-bg">
                {/* <ActionHeader header={dashboard.UpdateNominee.UpdateNomineeHeading} /> */}
                <div className="curved-bg-content curved-bg-table-outer">
                  <div className="curved-bg-content-table">
                    <h5> {dashboard.UpdateNominee.UpdateNomineeInfo}</h5>
                    <div className="curved-table-content">
                      {currentKey && (loading || rowData.length) ? (
                        TableBody
                      ) : (
                        <NoFoliosFound
                          info={dashboard.UpdateNominee.EmptyNomineeInfo}
                        />
                      )}
                    </div>
                    {/* <FaqLink section={UPDATE_NOMINEE} history={props.history} /> */}
                  </div>
                  <div className="curved-bg-content-inner-bottom">
                    <div className="table-submit">
                      <SubmitButton
                        onClick={() => {
                          dispatch({
                            type: INITIALIZE_NOMINEE_ARRAY,
                            body: { payload: selectedRows },
                          });
                          props.history.push(
                            "/new-transaction/nct-type/update-ind-nominee",
                            {
                              selectedRows,
                            }
                          );
                        }}
                        className="customBtn"
                        disabled={!selectedRows.length}
                        label={dashboard.UpdateNominee.buttonNext}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
}

export default connect(
  ({ authReducer, investor }: RootStateType) => ({
    ...authReducer,
    ...investor,
  }),
  { fetchInvestorDetails }
)(Nominee);
